import { render, staticRenderFns } from "./HrDashboardStats.vue?vue&type=template&id=29bd5e85&scoped=true"
import script from "./HrDashboardStats.vue?vue&type=script&lang=js"
export * from "./HrDashboardStats.vue?vue&type=script&lang=js"
import style0 from "./HrDashboardStats.vue?vue&type=style&index=0&id=29bd5e85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bd5e85",
  null
  
)

export default component.exports